import { useEffect, useState } from 'react'
import { isStandalone } from '../pwa'

const DISMISSED_KEY = 'install-prompt-dismissed'

function isIos() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent)
}

// Nudges family members to install the app. Android/desktop get a real install button;
// iOS has no install API, so it gets the Share-sheet instructions instead.
export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null)
  const [showIosHint, setShowIosHint] = useState(false)

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISSED_KEY)) return

    function onBeforeInstallPrompt(event) {
      event.preventDefault()
      setDeferredPrompt(event)
    }

    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt)

    if (isIos()) setShowIosHint(true)

    return () => window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt)
  }, [])

  function dismiss() {
    localStorage.setItem(DISMISSED_KEY, '1')
    setDeferredPrompt(null)
    setShowIosHint(false)
  }

  async function install() {
    if (!deferredPrompt) return
    deferredPrompt.prompt()
    await deferredPrompt.userChoice
    dismiss()
  }

  if (!deferredPrompt && !showIosHint) return null

  return (
    <div className="card-cute animate-pop-in mb-6 flex flex-wrap items-center gap-4 p-4">
      <span className="animate-float-slow text-3xl" aria-hidden="true">
        📲
      </span>

      <div className="min-w-[12rem] flex-1">
        <p className="font-display font-extrabold text-ink">Keep the album on your home screen</p>
        <p className="text-sm text-ink-soft">
          {deferredPrompt
            ? 'Install it once and it opens like a normal app — even offline.'
            : 'Tap Share, then “Add to Home Screen”, and it opens like a normal app.'}
        </p>
      </div>

      <div className="flex gap-2">
        {deferredPrompt && (
          <button type="button" onClick={install} className="btn-cute bg-blush-400 text-sm text-white shadow hover:bg-blush-500">
            Install
          </button>
        )}
        <button
          type="button"
          onClick={dismiss}
          className="btn-cute border-2 border-blush-100 bg-white text-sm text-ink-soft hover:bg-blush-50"
        >
          Not now
        </button>
      </div>
    </div>
  )
}
